import messageExtension from 'shared/utils/messageExtension'
import poll from 'shared/utils/poll'
import tryCatch from 'shared/utils/tryCatch'

// @vue/component
const isExtensionInstalled = {
	data() {
		return {
			isExtensionInstalled: undefined,
			extensionMetadataPoll: poll(() => messageExtension('getExtensionMetadata'), {
				interval: 200,
				maxAttempts: 5,
				validate: metadata => metadata?.version,
			}),
		}
	},
	async mounted() {
		const [error] = await tryCatch(this.extensionMetadataPoll.start)

		if (error) {
			this.isExtensionInstalled = false
			return
		}

		this.isExtensionInstalled = true
	},
	unmounted() {
		this.extensionMetadataPoll.stop()
	},
}

export default isExtensionInstalled
